<template>
  <div class="small-container pb-5">
    <div class="mb-3 text-left">
      <hl-H1>Tilleggsinformasjon</hl-H1>
      <p>
        Siden du valgte å forvalte leieforholdet med {{ depAccount.tenant.fullName }} via Husleie.no må vi ha noe mer
        informasjon fra deg
      </p>
    </div>

    <div class="row mt-5 mb-5">
      <div class="col-12 col-md-6 mt-4 mt-md-0">
        <hl-Input
          type="text"
          label="Bankkonto for overføring av husleien"
          placeholder="12341212345"
          v-model="depAccount.rent.accountNumber"
          name="rent.accountNumber"
          v-validate
        />
      </div>
    </div>

    <!-- Select Forfallsdato -->
    <div class="row mt-4">
      <div class="col-6">
        <hl-Select
          :options="payDayOptions"
          placeholder="Velg forfallsdag"
          label="Forfallsdag"
          v-model="depAccount.rent.payDay"
          name="rent.payDay"
          v-validate
        ></hl-Select>
      </div>

      <div class="col-6">
        <hl-Select
          :options="rentPeriodOptions"
          placeholder="Velg husleieperiode"
          label="Husleieperiode"
          v-model="depAccount.rent.rentPeriod"
          name="rent.rentPeriod"
          v-validate
        ></hl-Select>
      </div>
    </div>
    <!-- / Select Forfallsdato -->
    <div class="row mt-5 mb-5 pb-5">
      <div class="col">
        <hl-Select
          :options="oppsigelsestidOptions"
          placeholder="Velg oppsigelsestid"
          label="Oppsigelsestid for leieforholdet"
          v-model="depAccount.rent.noticePeriod"
          name="rent.noticePeriod"
          v-validate
        ></hl-Select>
      </div>
    </div>

    <hl-NextBackBottomBar
      buttonSize="lg"
      backText="tilbake"
      :backLink="getBackLink"
      nextLink="sign"
      nextText="neste"
      @validateAll="$validator.validateAll()"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Input from '@/components/Input.vue';
import NextBackBottomBar from '@/components/NextBackBottomBar.vue';
import Select from '@/components/Select.vue';
import H1 from '@modules/husleie-framework/src/components/headings/H1.vue';
import hlValidateBeforeLeave from '@modules/husleie-framework/src/mixins/hlValidateBeforeLeave';

export default {
  mixins: [hlValidateBeforeLeave],
  props: {
    depAccount: Object,
  },
  components: {
    'hl-H1': H1,
    'hl-Select': Select,
    'hl-Input': Input,
    'hl-NextBackBottomBar': NextBackBottomBar,
  },
  data() {
    return {
      oppsigelsestidOptions: [
        { name: 'Ingen oppsigelsestid', value: '0' },
        { name: '1 måned', value: '1' },
        { name: '2 måneder', value: '2' },
        { name: '3 måneder', value: '3' },
        { name: '4 måneder', value: '4' },
        { name: '5 måneder', value: '5' },
        { name: '6 måneder', value: '6' },
        { name: '7 måneder', value: '7' },
        { name: '8 måneder', value: '8' },
        { name: '9 måneder', value: '9' },
        { name: '10 måneder', value: '10' },
        { name: '11 måneder', value: '11' },
        { name: '12 måneder', value: '12' },
      ],

      payDayOptions: [
        { name: '1', value: '1' },
        { name: '5', value: '5' },
        { name: '10', value: '10' },
        { name: '15', value: '15' },
        { name: '20', value: '20' },
        { name: '25', value: '25' },
      ],

      rentPeriodOptions: [
        { name: 'neste måned (forskudd)', value: 'advance' },
        { name: 'inneværende måned', value: 'current' },
        { name: 'forrige måned (etterskudd)', value: 'postpay' },
      ],
    };
  },

  computed: {
    ...mapGetters('common/features', ['getFeature']),
    getBackLink() {
      const isPlanDisabled = this.getFeature('tenancySubscripition').isDisabled;
      return isPlanDisabled ? 'deposit' : 'plan';
    },
  },

  mounted() {
    /* GTM Tracking */
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'VirtualPageview',
      virtualPageURL: '/depositaccount/step4/info',
      virtualPageTitle: 'Deposit Account | Step 4 | Info',
    });
  },
};
</script>
